import { render, staticRenderFns } from "./SocialGrouped.vue?vue&type=template&id=41550294&"
import script from "./SocialGrouped.vue?vue&type=script&lang=js&"
export * from "./SocialGrouped.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.mediaworkflow.winnipeg.ca/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41550294')) {
      api.createRecord('41550294', component.options)
    } else {
      api.reload('41550294', component.options)
    }
    module.hot.accept("./SocialGrouped.vue?vue&type=template&id=41550294&", function () {
      api.rerender('41550294', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/SocialGrouped.vue"
export default component.exports